import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';
import { HeadCell, TableCell, TableCellWithSorting, Typography } from '../../../../ui-kit';
import { Row } from './types';

interface TableHeadCellsProps {
    headCell: HeadCell<Row>;
    index: number;
    markupSort: string | false;
    setMarkupSort(arg: string | false): void;
    grossRevenueSort: string | false;
    setGrossRevenue(arg: string | false): void;
    averageBillSort: string | false;
    setAverageBillSort(arg: string | false): void;
    billCountSort: string | false;
    setBillCountSort(arg: string | false): void;
}

const TableHeadCells = ({
    headCell,
    index,
    grossRevenueSort, setGrossRevenue,
    averageBillSort, setAverageBillSort,
    billCountSort, setBillCountSort
}: TableHeadCellsProps) => {
    const { t } = useTranslation();
    let tableHeadCellContent: React.ReactNode;

    switch (headCell.id) {
        case 'grossRevenue':
            tableHeadCellContent = (
                <TableCellWithSorting
                    align={headCell.align}
                    label={headCell.label}
                    sort={grossRevenueSort}
                    setSort={setGrossRevenue}
                />
            );
            break;
        case 'averageBill':
            tableHeadCellContent = (
                <TableCellWithSorting
                    align={headCell.align}
                    label={headCell.label}
                    sort={averageBillSort}
                    setSort={setAverageBillSort}
                />
            );
            break;
        case 'billCount':
            tableHeadCellContent = (
                <TableCellWithSorting
                    align={headCell.align}
                    label={headCell.label}
                    sort={billCountSort}
                    setSort={setBillCountSort}
                />
            );
            break;
        default:
            tableHeadCellContent = (
                <Typography
                    align={headCell.align}
                    uppercase
                    color='textSecondary'
                    variant='caption'
                >
                    {t(...headCell.label)}
                </Typography>
            );
            break;
    }
    return (
        <TableCell
            id={headCell.id as string}
            key={headCell.id as string}
            align={headCell.align}
            isTableHead
            isSticky={index === 0}
            padding='none'
        >
            <Box m={2}>
                {tableHeadCellContent}
            </Box>
        </TableCell>
    );
};

export default TableHeadCells;
